import styled from 'styled-components'

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  overflow: hidden;
`

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`

export const ListActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  > div {
    display: flex;
    gap: 4px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`

export const ListContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`

export const ListView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const GridView = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;

  h3 {
    margin: 16px 0 8px;
    font-size: ${({ theme }) => theme.typography.fontSize.title};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  p {
    margin: 0 0 24px;
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    color: ${({ theme }) => theme.colors.text.secondary};
    max-width: 400px;
  }
`

export const ListFooter = styled.div`
  padding: 16px 20px;
  background: white;
  border-top: 1px solid ${({ theme }) => theme.colors.border.default};
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > span {
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  > div {
    display: flex;
    align-items: center;
    gap: 8px;

    > span {
      padding: 0 12px;
      font-size: ${({ theme }) => theme.typography.fontSize.small};
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`

export const BulkActionsBar = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 20px;
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  z-index: 100;
  animation: slideUp 0.3s ease-out;

  > span {
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  > div {
    display: flex;
    gap: 8px;
  }

  @keyframes slideUp {
    from {
      transform: translateX(-50%) translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    left: 10px;
    right: 10px;
    transform: none;
    width: calc(100% - 20px);

    @keyframes slideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }
  }
`

export const FilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 20px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};

  > div {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: white;
    border: 1px solid ${({ theme }) => theme.colors.border.default};
    border-radius: ${({ theme }) => theme.borderRadius.small};
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    color: ${({ theme }) => theme.colors.text.primary};

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;

      svg {
        width: 12px;
        height: 12px;
        color: ${({ theme }) => theme.colors.text.secondary};
      }

      &:hover svg {
        color: ${({ theme }) => theme.colors.text.primary};
      }
    }
  }
`
